import { createComponent, ComponentProps } from '@/internals/utils';
export type DrawerActionsProps = ComponentProps;

const DrawerActions = createComponent({ name: 'DrawerActions' });

export default DrawerActions;
